<template>
	<div style="display: contents;">
		<!-- Trigger: variante toolbar -->
		<template v-if="buttonComponent == 'v-btn'">
			<v-tooltip top>
				<template v-slot:activator="{ on: tooltip }">
					<v-btn
						v-on="{ ...tooltip }"
						icon
						:disabled="disabled"
						:color="button.color || ''"
						@click="openDialog"
					>
						<v-icon>{{ button.icon || 'assignment' }}</v-icon>
					</v-btn>
				</template>
				<span>{{ button.tooltip || 'Genera ordine di Vendita' }}</span>
			</v-tooltip>
		</template>

		<!-- Trigger: variante dropdown menu -->
		<v-list-item
			v-else-if="buttonComponent == 'v-list-item'"
			dense
			:disabled="disabled"
			@click.stop="openDialog"
			ripple
		>
			<v-list-item-icon>
				<v-icon style="font-size: 18px">{{ button.icon || 'assignment' }}</v-icon>
			</v-list-item-icon>
			<v-list-item-content>
				<v-list-item-title>{{ button.tooltip || 'Genera ordine di Vendita' }}</v-list-item-title>
			</v-list-item-content>
		</v-list-item>

		<!-- Dialog -->
		<v-dialog v-model="dialog" max-width="600" persistent>
			<v-card class="round-card background-1">
				<v-card-title class="pa-3">
					<p class="pl-2 pl-xl-3">{{ button.mainTitle || 'Genera ordine di vendita' }}</p>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-divider></v-divider>

				<v-container fluid class="pt-3" style="min-height: 150px;">
					<div v-if="!loaded" class="d-flex justify-center align-center" style="min-height: 120px;">
						<v-progress-circular indeterminate color="primary"></v-progress-circular>
					</div>

					<!-- Modalità "modifica preventivo": scelta dei blocchi/opzioni da tenere -->
					<template v-else-if="showSelection">
						<p class="body-2 px-2 mb-1">Seleziona i blocchi (opzioni) da <strong>tenere</strong>:</p>
						<v-list dense class="background-1 py-0">
							<v-list-item v-for="(block, i) in blocks" :key="i" @click="toggle(i)" ripple>
								<v-list-item-action class="mr-3 my-0">
									<v-checkbox :input-value="selected[i]" readonly hide-details class="ma-0 pa-0"></v-checkbox>
								</v-list-item-action>
								<v-list-item-content>
									<v-list-item-title>{{ block.label }}</v-list-item-title>
									<v-list-item-subtitle>{{ block.count }} {{ block.count === 1 ? 'prodotto' : 'prodotti' }}</v-list-item-subtitle>
								</v-list-item-content>
								<v-list-item-action class="my-0">
									<span class="font-weight-bold">{{ block.total | currency(2, currency) }}</span>
								</v-list-item-action>
							</v-list-item>
						</v-list>
						<v-divider class="my-2"></v-divider>
						<div class="d-flex justify-space-between align-center px-2 mb-2">
							<strong>Totale ordine selezionato</strong>
							<strong class="primary--text">{{ selectedTotal | currency(2, currency) }}</strong>
						</div>
						<v-alert dense text type="warning" class="mx-2 mb-0 caption">
							Le opzioni non selezionate verranno <strong>eliminate dal preventivo</strong>, così ordine e preventivo coincidono. Per conservare l'offerta completa, duplica prima il preventivo.
						</v-alert>
					</template>

					<!-- Modalità standard (o preventivo senza opzioni): conferma semplice, copia tutto -->
					<template v-else>
						<p class="body-2 px-2">{{ button.secondTitle || 'Verrà creato un ordine con tutte le righe del preventivo.' }}</p>
					</template>
				</v-container>

				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text color="info" @click="closeDialog">Annulla</v-btn>
					<v-btn text color="primary" @click="submit" :loading="loading" :disabled="showSelection && !anySelected">Genera ordine</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
export default {
	name: 'generate-saleorder-button',
	props: {
		button: { type: Object, default: () => ({}) },
		params: { type: Object, default: () => ({}) },
		id: { type: [Number, String], default: null },
		model: { type: Object, default: () => ({}) },
		info: { type: Object, default: () => ({}) },
		modelDef: { type: String, default: '' },
		disabled: { type: Boolean, default: false },
		buttonComponent: { type: String, default: 'v-btn' },
	},
	data() {
		return {
			dialog: false,
			loading: false,
			loaded: false,
			hasSubtotals: false,
			blocks: [],
			selected: [],
		}
	},
	computed: {
		currency() {
			return (this.model && this.model.currency) ? this.model.currency : 'EUR'
		},
		selectOptionMode() {
			return !!this.$store.getters.checkSettings('quotation_order_select_option')
		},
		showSelection() {
			return this.selectOptionMode && this.hasSubtotals
		},
		anySelected() {
			return this.selected.some(Boolean)
		},
		selectedTotal() {
			return this.blocks.reduce((sum, block, i) => sum + (this.selected[i] ? (block.total || 0) : 0), 0)
		},
	},
	methods: {
		openDialog() {
			this.dialog = true
			if (this.loaded) return
			if (this.selectOptionMode) {
				this.fetchBlocks()
			} else {
				// Modalità standard: conferma semplice, nessun fetch.
				this.loaded = true
			}
		},

		closeDialog() {
			this.dialog = false
		},

		fetchBlocks() {
			const url = (this.button.blocks_url || 'quotations-saleorder-blocks') + '/' + this.id
			this.axios.get(url).then(response => {
				this.hasSubtotals = !!response.data.has_subtotals
				this.blocks = response.data.blocks || []
				this.selected = this.blocks.map(() => true)
				this.loaded = true
			}).catch(() => {
				// In caso di errore non blocco la conversione: fallback "copia tutto".
				this.hasSubtotals = false
				this.blocks = []
				this.selected = []
				this.loaded = true
			})
		},

		toggle(i) {
			this.$set(this.selected, i, !this.selected[i])
		},

		submit() {
			if (!this.id) {
				this.$store.commit('setSnackbar', { timeout: 4000, text: 'ID preventivo mancante', value: true, color: 'error' })
				return
			}

			const config = {}
			if (this.showSelection) {
				// Elimina dal preventivo i blocchi NON selezionati (prodotti + marker subtotale),
				// poi il backend converte tutto ciò che resta -> ordine = preventivo modificato.
				const remove = this.blocks.reduce((acc, block, i) => {
					if (!this.selected[i]) {
						acc.push(...(block.product_ids || []))
						if (block.subtotal_id) acc.push(block.subtotal_id)
					}
					return acc
				}, [])
				config.params = { remove_product_ids: remove }
			}

			this.loading = true
			const url = (this.button.url || 'quotations-saleorders') + '/' + this.id
			this.axios.get(url, config).then(response => {
				this.loading = false
				this.dialog = false
				this.$store.commit('setSnackbar', { timeout: 6000, text: 'Ordine di vendita generato', value: true, color: 'success' })
				const newId = response.data && response.data[this.button.id_key || 'id']
				const route = this.button.route || 'saleorders-show'
				if (newId) {
					this.$eventBusUtility.goTo(this.$router, route, newId, null, this.button.params || null)
				}
			}).catch(error => {
				this.loading = false
				this.$store.commit('setSnackbar', {
					timeout: 5000,
					text: (error.response && error.response.data && error.response.data.message) || 'Errore generazione ordine',
					value: true,
					color: 'error',
				})
			})
		},
	},
}
</script>
